import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'

import { getStateCurrent } from 'institutions'

import ImageAd from '../ImageAd'
import { getCampaign } from './adsList'

import './index.css'

class ImageAdHolder extends PureComponent {
  render() {
    const { className, disable, hidden, institution, name, noView, style, type } = this.props
    const campaign = getCampaign(institution?.id, institution?.tournament?.id, type)

    if (campaign) {
      const index = Math.floor(Math.random() * campaign.ads[type].length)
      const image = `${campaign.campaign.basePath}${campaign.ads[type][index]}`

      const link = [
        'utm_source=SweatBits',
        'utm_medium=Banner',
        `utm_campaign=${encodeURIComponent(campaign.campaign.name)}`,
        `utm_term=${encodeURIComponent(name)}`,
        `utm_content=${type}-${index}`,
      ].join('&')

      return (
        <ImageAd
          campaign={campaign.campaign.name}
          className={classnames('ImageAdHolder', className)}
          client={campaign.client.name}
          disable={disable}
          hidden={hidden}
          image={image}
          link={`${campaign.campaign.link}?${link}`}
          name={name}
          noView={noView}
          style={style}
        />
      )
    }

    return (
      <a
        className={classnames('ImageAdHolder ImageAdHolderEmpty', className)}
        href="mailto:info@sweatbits.co"
        rel="nofollow noopener noreferrer"
        style={style}
      >
        <div style={{ lineHeight: 'normal', textTransform: 'none' }}>info@sweatbits.co</div>
      </a>
    )
  }
}

ImageAdHolder.propTypes = {
  name: PropTypes.string.isRequired,

  className: PropTypes.string,
  disable: PropTypes.bool,
  hidden: PropTypes.bool,
  institution: PropTypes.shape({
    id: PropTypes.string,
    tournament: PropTypes.shape({ id: PropTypes.string }),
  }),
  noView: PropTypes.bool,
  style: PropTypes.object,
  type: PropTypes.oneOf(['100', '120', '260', '300', '550']),
}

ImageAdHolder.defaultProps = {
  className: null,
  disable: false,
  hidden: false,
  institution: null,
  noView: false,
  style: null,
  type: '260',
}

export class Pure extends ImageAdHolder {}
Pure.displayName = 'ImageAdHolder'

export default connect((state) => ({
  institution: getStateCurrent(state),
  tournament: state.tournament.data?.[0]?.tournament?.tournament,
}))(ImageAdHolder)
